import { render, staticRenderFns } from "./zg.vue?vue&type=template&id=5d01f6db&scoped=true"
var script = {}
import style0 from "./zg.vue?vue&type=style&index=0&id=5d01f6db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01f6db",
  null
  
)

export default component.exports